import {Box, Button, ButtonGroup, Grid} from '@mui/material';
import {CatalogComponent} from '../../../../api/models';
import {TextComponent} from '../../../RetailerWebScreen/components/TextComponent';
import {useContext, useEffect} from 'react';
import {CartContext} from '../../../../api/context';
import {CartTotalView} from './CartTotalView';

// demo this off using Context. Just ship / demo some shit that works hypothetically. Post the demo look into clean up
const AddToCartButton = ({item}: {item: CatalogComponent}) => {
    const context = useContext(CartContext);
    const quantity = context?.getCartItem(item.id)?.quantity ?? 0;

    const handleIncrement = () => {
        context?.updateCart(item.id, quantity + 1);
    };

    const handleDecrement = () => {
        if (quantity > 0) {
            context?.updateCart(item.id, quantity - 1);
        }
    };

    return (
        <Box>
            <ButtonGroup>
                <Button variant='contained' onClick={handleDecrement}>
                    -
                </Button>
                <Button
                    style={{
                        backgroundColor: 'white',
                    }}>
                    {quantity} pcs
                </Button>
                {/* Display count as disabled */}
                <Button variant='contained' onClick={handleIncrement}>
                    +
                </Button>
            </ButtonGroup>
        </Box>
    );
};

const CatalogItem = ({item}: {item: CatalogComponent}) => {
    return (
        <Grid style={{marginBottom: 24}} item md={6} sm={12} xs={12} lg={4} xl={4}>
            <center>
                <img
                    height={192}
                    width={192}
                    srcSet={item.image.url}
                    src={item.image.url}
                    alt={`Shop Image ${item.image.url}`}
                    loading='lazy'
                />
            </center>
            <TextComponent variant='h6' content={'Price: Rs.' + item.price.text} fontWeight={300} />
            <TextComponent variant='h5' content={item.title.text} fontWeight={600} />
            <TextComponent variant='body1' content={item.subtitle.text} fontWeight={300} />
            <AddToCartButton item={item} />
        </Grid>
    );
};

/**
 * the functions below can be abstracted to be more readable, this is very messy
 * @param param0
 * @returns
 */
export const CatalogueItemsListWithContext = ({catalogItems}: {catalogItems: CatalogComponent[]}) => {
    const context = useContext(CartContext);
    const websiteId = context?.getWebsiteId();

    useEffect(() => {
        if (websiteId) {
            context?.setCatalogItems(catalogItems);
        }
    }, [websiteId, catalogItems]);

    return (
        <>
            <Box>
                <Grid container>
                    {catalogItems.map((item: CatalogComponent) => {
                        return <CatalogItem item={item} />;
                    })}
                </Grid>
            </Box>
            <CartTotalView />
        </>
    );
};
